if (!customElements.get('about-editorial-reveal')) {
  class AboutEditorialReveal extends HTMLElement {
    observer;

    connectedCallback() {
      if (window.Shopify?.designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.classList.add('is-visible');
        return;
      }

      this.classList.add('is-reveal-pending');

      if (!('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }

      this.observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry?.isIntersecting) return;
          this.classList.add('is-visible');
          this.observer?.disconnect();
        },
        { threshold: 0.16, rootMargin: '0px 0px -6% 0px' }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('about-editorial-reveal', AboutEditorialReveal);
}
